import UserFormList from '@/components/admin/userform/UserFormList'
import UserFormBulkOps from '@/components/admin/userform/bulkops/UserFormBulkOps'
import UserForm from '@/components/admin/userform/UserForm'
import UserFormImport from '@/components/admin/userform/import/UserFormImport'
import LegacyUserFormImport from '@/components/admin/userform/import/LegacyUserFormImport'
import auth from './../auth'

export default [
  {
    path: '/admin/userforms/list',
    name: 'UserFormList',
    component: UserFormList,
    beforeEnter: auth.ifAuthenticated
  },
  {
    path: '/admin/userforms/bulk',
    name: 'UserFormBulkOps',
    component: UserFormBulkOps,
    beforeEnter: auth.ifAuthenticated
  },
  {
    path: '/admin/userforms/import/legacy',
    name: 'LegacyUserFormImport',
    component: LegacyUserFormImport,
    beforeEnter: auth.ifAuthenticated
  },
  {
    path: '/admin/userforms/import',
    name: 'UserFormImport',
    component: UserFormImport,
    beforeEnter: auth.ifAuthenticated
  },
  {
    path: '/admin/userforms/:id?',
    name: 'UserForm',
    component: UserForm,
    meta: { fullWidth: true },
    beforeEnter: auth.ifAuthenticated
  }
]
